export const MILISECONDS = {
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000,
};

export const MINUTES = {
  MINUTE: 1,
  HOUR: 60,
  DAY: 1440,
};

export const TIME_PLACEHOLDER = '--:--';
